import {Route} from '@angular/router';
import {ContactComponent} from './contact/contact.component';
import {HomeComponent} from './home/home.component';
import {ServicesComponent} from './services/services.component';
import {FaqComponent} from './faq/faq.component';
import {SalvageYardManagementComponent} from "./services/salvage-yard-management/salvage-yard-management.component";
import {WasteCollectionComponent} from "./services/waste-collection/waste-collection.component";
import {SupplyAndDeliveryComponent} from "./services/supply-and-delivery/supply-and-delivery.component";
import {PlantHireComponent} from "./services/plant-hire/plant-hire.component";
import {CleaningServiceComponent} from "./services/cleaning-service/cleaning-service.component";
import {IllegalDumpsComponent} from "./services/illegal-dumps/illegal-dumps.component";
import {AboutComponent} from "./about/about/about.component";
import {WhoAreWeComponent} from "./about/who-are-we/who-are-we.component";
import {WhatWeDoComponent} from "./about/what-we-do/what-we-do.component";
import {SellingPointComponent} from "./about/selling-point/selling-point.component";
import {CompanyComponent} from "./company/company/company.component";
import {MissionComponent} from "./company/mission/mission.component";
import {BackgroundComponent} from "./company/background/background.component";
import {VisionComponent} from "./company/vision/vision.component";
import {ValuesComponent} from "./company/values/values.component";
import {ObjectivesComponent} from "./company/objectives/objectives.component";
import {ProductsComponent} from "./products/products.component";


export const routerConfig: Route[] = [
  {
    path: 'home',
    component: HomeComponent
  },
  {
    path: 'products',
    component: ProductsComponent
  },
  {
    path: 'about',
    children: [{
      path: '',
      component: AboutComponent
    }, {
      path: 'who-are-we',
      component: WhoAreWeComponent
    }, {
      path: 'what-we-do',
      component: WhatWeDoComponent
    }, {
      path: 'selling-point',
      component: SellingPointComponent
    }]
  },
  {
    path: 'services',
    children: [{
      path: '',
      component: ServicesComponent
    }, {
      path: 'salvage-yard-management',
      component: SalvageYardManagementComponent
    }, {
      path: 'waste-collection',
      component: WasteCollectionComponent
    }, {
      path: 'supply-and-delivery',
      component: SupplyAndDeliveryComponent
    }, {
      path: 'plant-hire',
      component: PlantHireComponent
    }, {
      path: 'cleaning-service',
      component: CleaningServiceComponent
    }, {
      path: 'illegal-dumps',
      component: IllegalDumpsComponent
    }]
  },
  {
    path: 'company',
    children: [{
      path: '',
      component: CompanyComponent
    }, {
      path: 'mission',
      component: MissionComponent
    }, {
      path: 'background',
      component: BackgroundComponent
    }, {
      path: 'vission',
      component: VisionComponent
    }, {
      path: 'values',
      component: ValuesComponent
    }, {
      path: 'objectives',
      component: ObjectivesComponent
    }]
  },
  {
    path: 'contact',
    component: ContactComponent
  },
  {
    path: 'faq',
    component: FaqComponent
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: ''
  }
]



// WEBPACK FOOTER //
// /Users/dev-man/Kgwetlwo-app/src/app/pages/router.config.ts